module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Chat#6-59d2432114563954746d1645898dd150.svg";